export const CHANGE_STATE_IVS = 'CHANGE_STATE_IVS';
export const HIGHLIGHTED = 'HIGHLIGHTED';
export const COUNTDOWN = 'COUNTDOWN';
export const ADD_PRODUCT_TO_VIDEO = 'ADD_PRODUCT_TO_VIDEO';
